import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_n8c9ufkxt7: FaireCollectionEntity = {
  token: "pbc_n8c9ufkxt7",
  type: "collection",
  name: "WEAR NOW",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7f3c73a38055117ae2421689137e01efe484872d265b1dd2fa1481f40c0a7c7e.jpeg",
  itemCount: 28,
  brandToken: "b_q8gu9by5sv",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:48:54.737Z",
    importedBy: "entity-db-import-collections",
  },
};
